import React from 'react';
import { STATIC_INDICATION_TYPES, INDICATION_TYPES } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { BROWSER_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/browser/browserReportId';
import { DMA_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/dma/dmaReportId';
import { OS_FAMILY_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/os-family/osFamilyReportId';
import { OS_VERSION_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/os-version/osVersionReportId';
import { REGION_REPORT_ID } from '../../../modules/campaigns-reports/config/reports/region/regionReportId';

// Data is available from November 2022 onward
export const HISTORICAL_DATA_AVAILABLE_FROM_DATE = '2022-11-01';

// Reports that only have 2 years of data
export const REPORTS_WITH_TWO_YEARS_DATA = [
    BROWSER_REPORT_ID,
    OS_FAMILY_REPORT_ID,
    OS_VERSION_REPORT_ID,
    REGION_REPORT_ID,
    DMA_REPORT_ID,
];

// Indication for when a user selects a date range that includes dates before November 2022
export const historicalDataNotAvailableIndication = {
    staticIndicationType: STATIC_INDICATION_TYPES.PARTIAL_REPORT_DATA,
    type: INDICATION_TYPES.WARNING,
    iconTypeOverride: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.historicalDataNotAvailableWarning.highlight"
            defaultMessage="Data is available from November 2022 onward."
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.historicalDataNotAvailableWarning.message"
            defaultMessage="Please select a date range within this period."
        />
    ),
};

// Indication for reports that only have 2 years of data
export const twoYearsDataLimitIndication = {
    staticIndicationType: STATIC_INDICATION_TYPES.PARTIAL_REPORT_DATA,
    type: INDICATION_TYPES.WARNING,
    iconTypeOverride: INDICATION_TYPES.WARNING,
    highlight: (
        <FormattedMessage
            id="app.campaign.indication.twoYearsDataLimitWarning.highlight"
            defaultMessage="This report includes data from the past 2 years only."
        />
    ),
    message: (
        <FormattedMessage
            id="app.campaign.indication.twoYearsDataLimitWarning.message"
            defaultMessage="Please select a date range within that period."
        />
    ),
};
